import { Tree, Icon } from "antd";
// import Tree from '../../../_antd1.11.2/tree';
import WeaInputSearch from "../../wea-input-search";
const TreeNode = Tree.TreeNode;
// import Icon from '../../../_antd1.11.2/icon';
import WeaScroll from "../../wea-scroll";
import WeaNewScroll from "../../wea-new-scroll";
import cloneDeep from "lodash/cloneDeep";
import isArray from "lodash/isArray";
import trim from "lodash/trim";
import uniqBy from "lodash/uniqBy";
import debounce from "lodash/debounce";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;
let timeout = null;

const text = (item, field) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  return text;
};

export default class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      key: ""
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.data !== nextProps.data ||
      this.state.key !== nextState.key ||
      this.props.checkedKeys !== nextProps.checkedKeys
    );
  }
  count(item) {
    if (item.type === "all") return item.count;
    return (item.users || []).length;
  }
  generateTreeNodes() {
    const {
      data,
      inputId,
      inputName,
      inputTop,
      inputBottom,
      type,
      hideNum
    } = this.props;
    const { key } = this.state;
    const treeNodes = [];
    let showData = [...data];
    if (type == 1 || type == 17) {
      if (trim(key)) {
        showData = data.filter(item => {
          let bool = false;
          bool = item.lastname.indexOf(trim(key)) > -1;
          if (!bool && item.pingyinname) {
            bool = item.pingyinname.indexOf(trim(key)) > -1;
          }
          return bool;
        });
      }
      this.nodeIds = [];
      this.nodeObj = {};
      showData.map(item => {
        let title = null;
        let crmNames = [];
        if (item.departmentname) crmNames.push(item.departmentname);
        if (item.supsubcompanyname) crmNames.push(item.supsubcompanyname);
        if (item.subcompanyname) crmNames.push(item.subcompanyname);
        item.crmNames = crmNames.join("／");
        if (item.type == "subcom" || item.type == "com") {
          title = (
            <div className="tree-title">
              <i className="icon-process-scene" />
              <span title={item.lastname}>{item.lastname}</span>
              {!hideNum && `(${this.count(item)})`}
            </div>
          );
        } else if (item.type == "dept") {
          title = (
            <div className="tree-title">
              <i className="icon-mail-folder" />{" "}
              <span title={item.lastname}>{item.lastname}</span>
              {!hideNum && `(${this.count(item)})`}
            </div>
          );
        } else if (item.type == "resource") {
          title = (
            <div className="tree-title resource">
              <img
                className="wea-tree-hr-portrait"
                src={item.icon}
                onError={() =>
                  (item.icon =
                    "/cloudstore/resource/pc/com/images/portrait_default.jpg")
                }
                alt="img"
              />
              <div className="resource-content breakall">
                <div>
                  {inputTop || inputBottom
                    ? (inputTop || []).map(field => (
                        <span
                          style={{ marginRight: 5 }}
                          dangerouslySetInnerHTML={{
                            __html: text(item, field)
                          }}
                        />
                      ))
                    : [
                        <span className="lastname" title={item.lastname}>
                          {item.lastname}
                        </span>,
                        <span
                          className="jobtitlename gray"
                          title={item.jobtitlename}
                        >
                          {item.jobtitlename}
                        </span>
                      ]}
                </div>
                <div>
                  {inputTop || inputBottom ? (
                    (inputBottom || []).map(field => (
                      <span
                        style={{ marginRight: 5 }}
                        dangerouslySetInnerHTML={{ __html: text(item, field) }}
                      />
                    ))
                  ) : (
                    <div className="overflow gray" title={item.crmNames}>
                      {item.crmNames}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        } else {
          title = (
            <div className="tree-title">
              <i className="icon-process-scene" />
              <span title={item.lastname}>{item.lastname}</span>
              {!hideNum && `(${this.count(item)})`}
            </div>
          );
        }
        treeNodes.push(
          <TreeNode
            title={title}
            name={item.lastname}
            jobtitlename={item.jobtitlename}
            key={item.nodeid}
            isLeaf={true}
            id={item.id}
            type={item.type}
          />
        );
        this.nodeIds.push(item.nodeid);
        this.nodeObj[item.nodeid] = item;
      });
    } else if (inputId) {
      if (trim(key)) {
        showData = showData.filter(item => {
          // return encodeURI(item[inputTop[0]]).indexOf(encodeURI(trim(key))) > -1;
          if (inputTop.length > 0) {
            return item[inputTop[0]].indexOf(trim(key)) > -1;
          } else {
            return item[inputName] && item[inputName].indexOf(trim(key)) > -1;
          }
        });
      }
      showData = uniqBy(showData, inputId || "id");
      this.nodeIds = [];
      this.nodeObj = {};
      showData.map(item => {
        let top = [];
        let bottom = [];
        inputTop &&
          inputTop.forEach(field => {
            top.push(
              <span
                style={{ marginRight: "5px" }}
                dangerouslySetInnerHTML={{ __html: text(item, field) }}
              />
            );
          });
        inputBottom &&
          inputBottom.forEach(field => {
            bottom.push(
              <span
                style={{ marginRight: "5px" }}
                dangerouslySetInnerHTML={{ __html: text(item, field) }}
              />
            );
          });
        let title = (
          <div>
            <div className="item-wrap">
              <div className="item-top">{top}</div>
              <div className="item-bottom">{bottom}</div>
            </div>
          </div>
        );
        treeNodes.push(
          <TreeNode title={title} key={item[inputId]} isLeaf={true} />
        );
        this.nodeIds.push(item[inputId]);
        this.nodeObj[item[inputId]] = item;
      });
    }
    return treeNodes;
  }
  onSearchChange(v) {
    this.setState({ key: v });
  }
  reset() {
    this.setState({ key: "" });
  }
  checkHandler(v, p) {
    let _this = this;
    // 取消上次延时未执行的方法
    clearTimeout(timeout);
    //执行延时
    timeout = setTimeout(function() {
      _this.props.checkedCb && _this.props.checkedCb(v);
    }, 200);
  }
  onDoubleClick(key) {
    clearTimeout(timeout);
    this.props.onDoubleClick && this.props.onDoubleClick(key);
  }
  onDragStart(obj) {
    clearTimeout(timeout);
    this.props.checkedCb && this.props.checkedCb([]);
  }
  onDrop(obj) {
    const dragNodes = obj.dragNodesKeys;
    const targetNode = obj.node.props.eventKey;
    const result = [];
    this.nodeIds
      .filter(item => {
        return dragNodes.indexOf(item) === -1;
      })
      .forEach(id => {
        if (id === targetNode) {
          dragNodes.forEach(drag => {
            result.push(this.nodeObj[drag]);
          });
        }
        result.push(this.nodeObj[id]);
      });
    this.props.onDrag && this.props.onDrag(result);
  }
  render() {
    const { checkedKeys, height } = this.props;
    const treeNodes = this.generateTreeNodes();
    return (
      <div className="wea-transfer-right">
        <WeaInputSearch
          onSearchChange={debounce(this.onSearchChange, 200).bind(this)}
          placeholder={getLabel(83788, "请输入关键字搜索")}
          value={this.state.key}
        />
        <div>
          <WeaNewScroll height={height || 400}>
            <Tree
              className="transfer-tree"
              draggable
              onDragStart={this.onDragStart.bind(this)}
              onDrop={this.onDrop.bind(this)}
              onSelect={this.checkHandler.bind(this)}
              onDoubleClick={this.onDoubleClick.bind(this)}
              selectedKeys={checkedKeys}
              multiple={true}
              async={true}
              selectable={true}
            >
              {treeNodes}
            </Tree>
          </WeaNewScroll>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-muti-right/index.js